import { useEffect, useState } from 'react'

type EnvelopeAnimationProps = {
  size?: number
}

export function EnvelopeAnimation({ size = 80 }: EnvelopeAnimationProps) {
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="envelope-animation" style={{ width: size, height: size }}>
      <svg
        className={`envelope-animation__svg ${isAnimating ? 'envelope-animation__svg--animate' : ''}`}
        viewBox="0 0 64 64"
        fill="none"
      >
        <rect
          className="envelope-animation__body"
          x="6"
          y="16"
          width="52"
          height="36"
          rx="3"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="envelope-animation__flap"
          d="M6 19L32 38L58 19"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="envelope-animation__check"
          d="M22 34L28 40L42 26"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
